// extracted by mini-css-extract-plugin
export default {"base":"AccountError__base___1hRIN","description":"AccountError__description___3B30D"};